var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "status-table" } },
    [
      _c("a-table", {
        staticClass: "custom-table2",
        attrs: {
          columns: _vm.columns,
          dataSource: _vm.statuses,
          pagination: false,
          rowKey: "_id",
          size: "small",
        },
        scopedSlots: _vm._u([
          {
            key: "_id",
            fn: function (_id, item) {
              return _c("div", {}, [
                _c(
                  "div",
                  { staticClass: "button-container" },
                  [
                    _c(
                      "a-button",
                      {
                        staticClass: "actionButton",
                        on: {
                          click: function ($event) {
                            return _vm.$emit("edit", _id)
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "mr-1" }, [
                          _vm._v(_vm._s(_vm.$t("message.edit"))),
                        ]),
                        _vm._v(" "),
                        _c("ActionEdit"),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a-button",
                      {
                        staticClass: "actionButton",
                        on: {
                          click: function ($event) {
                            return _vm.deleteStatus(_id)
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "mr-1" }, [
                          _vm._v(_vm._s(_vm.$t("message.delete"))),
                        ]),
                        _vm._v(" "),
                        _c("ActionDelete"),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ])
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }